module.exports={pages:[{menu:"pizze-e-saltimbocca"},{menu:"antipasti"},{menu:"sfizio-e-dolci"},{menu:"birre-e-bibite"}]};